import { render, staticRenderFns } from "./ResolutionForm.vue?vue&type=template&id=d8ae3ffa&scoped=true"
import script from "./ResolutionForm.vue?vue&type=script&lang=js"
export * from "./ResolutionForm.vue?vue&type=script&lang=js"
import style0 from "./ResolutionForm.vue?vue&type=style&index=0&id=d8ae3ffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ae3ffa",
  null
  
)

export default component.exports